import { useState } from "react";
import { login } from "../service/login";

interface Props {
  setAuthentication: (val: boolean) => void;
}

const LoginFormView = ({ setAuthentication }: Props) => {
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");

  const handleSubmit = async () => {
    const token = await login(email, password);
    if (token) {
      setAuthentication(true);
    }
  };

  return (
    <div className="mx-auto gap-4 inline-flex flex-col">
      <div className="inline-flex flex-col">
        <span className="font-medium">Email</span>
        <input
          className="p-2 font-medium border border-gray-700"
          onChange={(evt) => setemail(evt.target.value)}
          type="email"
          name="email"
          id="email"
        />
      </div>
      <div className="flex flex-col">
        <span className="font-medium">Password</span>
        <input
          className="p-2 font-medium border border-gray-700"
          type="password"
          name=""
          id=""
          onChange={(evt) => setpassword(evt.target.value)}
        />
      </div>
      <button
        className="p-2 bg-primary text-light hover:bg-secondary"
        onClick={() => handleSubmit()}
      >
        Login
      </button>
    </div>
  );
};

export default LoginFormView;
